export const TELEHEALTH_ONLY_SLOT_TYPES: string[] = [
  'ABA Assessment: Parent Interview',
  'ABA Assessment: Observation',
  'ADIR',
  'ADIR Follow Up',
  'Care Plan Meeting',
  'Parent Training',
  'EEG Read',
  'NP Care Sessions',
  'ADOS Review'
];

export const isTelehealthOnlySlotType = (slotType: string): boolean => {
  return TELEHEALTH_ONLY_SLOT_TYPES.includes(slotType);
};
